<h5 translate>FILTERS</h5>
<div class="row">
  <div class="col-md-4">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="{{ 'FINANCIAL-GENERAL.ANIMALS.FILTER' | translate }}"
        [(ngModel)]="animalFilter"
        (input)="filterSearch()"
      />
      <button
        *ngIf="animalFilter != ''"
        class="btn bg-transparent"
        style="margin-left: -40px; z-index: 100; padding: 0"
        (click)="clearAnimalFilter()"
      >
        <i class="mdi mdi-for-btn mdi-close"></i>
      </button>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th translate>ANIMAL.SINGLE</th>
        <th translate>SUBSCRIPTIONS</th>
        <th translate>STALL</th>
        <th translate>TOTAL</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngIf="
          animalsPerm.length == 0 && animals.length == 0 && !isAnimalsLoading
        "
      >
        <td colspan="9" class="text-center" translate>
          ANIMAL.NOT-FOUND-EVENT-ANIMAL
        </td>
      </tr>
      <tr
        *ngIf="
          animalsPerm.length > 0 && animals.length == 0 && !isAnimalsLoading
        "
      >
        <td colspan="9" class="text-center" translate>ANIMAL.NOT-FOUND</td>
      </tr>
      <tr *ngIf="isAnimalsLoading">
        <td colspan="9">
          <div
            class="
              lds-dual-ring lds-dual-ring-black
              d-flex
              justify-content-center
              w-100
            "
          ></div>
        </td>
      </tr>
      <tr *ngFor="let item of animals">
        <td>
          <div
            (click)="open(item.horse)"
            class="btn btn-sm btn-outline-primary"
            translate
          >
            TAKEOFFS
          </div>
        </td>
        <td>
          {{ item.horse.name }}
        </td>
        <td>
          {{ item.subscriptions }}
        </td>
        <td>
          <span *ngIf="item.stall"
            >{{ item.stall.stall.stallType }} - {{ "CURRENCY" | translate
            }}{{ item.stall.stall.price }} - {{ item.stall.coach }}</span
          >
          <span *ngIf="!item.stall">-</span>
        </td>
        <td>{{ event.currency | currencyPipe }}{{ item.total }}</td>
      </tr>
    </tbody>
  </table>
</div>
